(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partnerliklerimiz"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initAnimations(scope) {
      var root = scope || document;
      var els = root.querySelectorAll('.js-prt-animate');
      if (!els.length) return;

      if (window.Shopify && window.Shopify.designMode) {
        els.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

      els.forEach(function(el) { observer.observe(el); });
    }

    initAnimations();

    document.addEventListener('shopify:section:load', function(event) {
      initAnimations(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
